import settings from './settings-store.mjs';
import { duckForStinger, unduckForStinger } from './media.mjs';

const STINGER_MAP = {
	'current-weather': 'current-conditions.mp3',
	'latest-observations': 'server-obs.mp3',
	hourly: 'hourly-forecast.mp3',
	travel: 'travel-forecast.mp3',
	'regional-forecast': 'regional-observations.mp3',
	radar: 'local-radar.mp3',
};

let currentStinger = null;

const stopStinger = () => {
	if (!currentStinger) return;
	currentStinger.pause();
	currentStinger.currentTime = 0;
	currentStinger = null;
	unduckForStinger();
};

const playStinger = (elemId) => {
	if (!settings.get('stingersEnabled')) return;
	const fileName = STINGER_MAP[elemId];
	if (!fileName) return;

	stopStinger();
	duckForStinger();

	const audio = new Audio(`audio/stingers/${fileName}`);
	currentStinger = audio;

	const cleanup = () => {
		if (currentStinger === audio) {
			currentStinger = null;
			unduckForStinger();
		}
	};

	audio.addEventListener('ended', cleanup);
	audio.addEventListener('error', cleanup);
	audio.play().catch(cleanup);
};

export { playStinger, stopStinger };
